import { render } from "./LocalizedLabel.vue?vue&type=template&id=013820b0"
import script from "./LocalizedLabel.vue?vue&type=script&lang=js"
export * from "./LocalizedLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__